import { createSelector } from 'reselect';
import { selectPageModelData } from '../store/pageModel/selectors';

export const getYaCode = createSelector(
	selectPageModelData,
	model => model?.analytics?.yaCode ?? null
);
